'use client';

import { FC, PropsWithChildren } from 'react';

import { LinkContext, type Routes } from '@lichtblick/link/helpers/link-context';

export const LinkContextProvider: FC<PropsWithChildren & { routes: Routes }> = ({ children, routes }) => (
  <LinkContext.Provider value={routes}>{children}</LinkContext.Provider>
);
